import { render, staticRenderFns } from "./instance-card.component.vue?vue&type=template&id=6535ada4&scoped=true"
import script from "./instance-card.component.vue?vue&type=script&lang=ts"
export * from "./instance-card.component.vue?vue&type=script&lang=ts"
import style0 from "./instance-card.component.vue?vue&type=style&index=0&id=6535ada4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535ada4",
  null
  
)

export default component.exports